import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ResultsPage } from '../components/ResultsPage';
import { notifyParentScrollTop } from '../lib/embedBridge';

function BusinessPricingThankYou() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { notifyParentScrollTop(); }, []);
  
  useEffect(() => {
    // Retrieve results from sessionStorage
    const storedData = sessionStorage.getItem('bonza_valuation_results');
    const businessEnquiryId = sessionStorage.getItem('formID');
    
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        setData(parsedData);
        
        const enquiryId = businessEnquiryId || parsedData.businessEnquiryId;
        
        // Fire tracking events with a small delay to ensure GTM is ready
        const fireTrackingEvents = () => {
          // Ensure dataLayer exists
          window.dataLayer = window.dataLayer || [];
          
          // IMPORTANT: Push gtm.historyChange to notify GTM of SPA navigation
          // This triggers GTM's built-in History Change listeners
          window.dataLayer.push({
            'event': 'gtm.historyChange',
            'gtm.historyChangeSource': 'pushState',
            'gtm.oldUrl': document.referrer || window.location.origin + '/business-pricing',
            'gtm.newUrl': window.location.href
          });
          
          // Also push a virtual page view for GA4
          window.dataLayer.push({
            'event': 'page_view',
            'page_title': 'Business Valuation Results',
            'page_location': window.location.href,
            'page_path': '/business-pricing-thank-you'
          });
          
          // Push virtual_page_view event
          window.dataLayer.push({
            'event': 'virtual_page_view',
            'page_title': 'Business Valuation Results',
            'page_location': window.location.href,
            'page_path': '/business-pricing-thank-you',
            'business_enquiry_id': enquiryId
          });
          
          // Push thank_you_page event for conversion tracking
          window.dataLayer.push({
            'event': 'thank_you_page_view',
            'event_category': 'conversion',
            'event_label': 'valuation_results_viewed',
            'valuation_low': parsedData.results?.valuationLow || 0,
            'valuation_high': parsedData.results?.valuationHigh || 0,
            'business_enquiry_id': enquiryId
          });
          
          console.log('GTM events pushed - historyChange + thank_you_page_view with ID:', enquiryId);
          
          // StackAdapt Programmatic tracking
          if (enquiryId) {
            // Initialize StackAdapt if not already loaded
            if (!window.saq) {
              (function(s,a,e,v,n,t,z){
                if(s.saq)return;
                n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!s._saq)s._saq=n;
                n.push=n;n.loaded=true;n.version='1.0';n.queue=[];
                t=a.createElement(e);t.async=true;t.src=v;
                z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z);
              })(window,document,'script','https://tags.srv.stackadapt.com/events.js');
            }
            
            // Fire StackAdapt conversion with Business Enquiry ID
            window.saq('conv', 'sdyHTq8UHqMavtCsnKlEee', {'order_id': enquiryId});
            console.log('StackAdapt conversion fired with order_id:', enquiryId);
          }
        };
        
        // Delay to ensure page is fully rendered and GTM is ready
        setTimeout(fireTrackingEvents, 500);
        
      } catch (e) {
        console.error('Failed to parse stored results:', e);
      }
    }
    
    setLoading(false);
  }, []);
  
  // Handle contact broker - redirect to success stories
  const handleContactBroker = () => {
    window.open('https://bonzabfs.com.au/success-stories', '_blank');
  };
  
  // Handle email result (already sent on submit)
  const handleEmailResult = async () => {
    // Email was already sent during form submission
    return Promise.resolve();
  };
  
  // If no data, redirect back to form
  if (!loading && !data) {
    return (
      <div className="bonza-container">
        <div className="bonza-card">
          <div className="p-8 text-center">
            <h2 className="text-xl font-semibold text-[#1A1523] mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              No Valuation Found
            </h2>
            <p className="text-[#64748B] mb-6">
              It looks like you haven't completed the valuation form yet.
            </p>
            <button
              onClick={() => navigate('/business-pricing')}
              className="bonza-btn-primary px-6 py-3 rounded-xl font-semibold text-white"
            >
              Start Your Free Valuation
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  if (loading) {
    return (
      <div className="bonza-container">
        <div className="bonza-card">
          <div className="p-8 text-center">
            <div className="w-12 h-12 border-4 border-[#5a2f92] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-[#5a2f92] font-medium">Loading your results...</p>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="bonza-container">
      <div className="bonza-card">
        <ResultsPage
          formData={data.formData}
          results={data.results}
          businessEnquiryId={data.businessEnquiryId || sessionStorage.getItem('formID')}
          onContactBroker={handleContactBroker}
          onEmailResult={handleEmailResult}
        />
      </div>
    </div>
  );
}

export default BusinessPricingThankYou;
